<template>
  <div class="home" style="width: 100%; height: 100%">
    <div style="width: 100%; height: 36.46vw" ref="main"></div>
    <p
      style="
        font-size: 16px;
        font-weight: normal;
        line-height: 1.56vw;
        height: 1.56vw;
        text-align: center;
        margin-top: 1.04vw;
        color: #6d6d6d;
      "
    >
      *地图经过变形处理，仅供参考。
    </p>
    <div class="plist" v-if="sf">
      <div class="lists">
        <div class="listtitle">
          <div class="titleleft titlesingle">{{ sf }}项目明细</div>
          <div class="titleright titlesingle">所属公司</div>
        </div>
        <div class="listcon" v-for="(i, j) in showlist">
          <div class="conleft consingle">{{ i.name }}</div>
          <div class="conright consingle">{{ i.belong }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//获取中国地图的json数据
import * as echarts from "echarts";
import chinaJson from "../assets/json/chinageo.json";
import mapdata from "../assets/js/inlayoutdata.js";
export default {
  data() {
    return {
      str: [
        "哈尔滨242医院项目部",
        "新建哈尔滨至铁力铁路房项目",
        "东北亚博览城项目",
        "沈白铁路项目",
        "西城区大栅栏煤市街综合用地项目",
        "城市副中心交通枢纽项目",
        "北京城市副中心图书馆项目",
        "中兵未来科研中心项目",
        "北京西北旺安置住房统建项目",
        "安宁庄住宅 (A区、B区) 项目",
        "121项目",
        "北京园博数字经济产业园项目",
        "匝道桥2#标项目",
        "北京调度所应急指挥中心 改造项目",
        "北京审计中心办公楼装修项目",
        "丰台站地下一层地铁换乘厅项目",
        "廊坊临空家园项目",
        "廊坊东尖塔村棚改项目",
        "国网蒙东电科院生产试验综合用房项目",
        "玉兰广场项目",
        "大厂站配套市政道路项目",
        "地球物理中心项目",
        "雄安城际站站房及相关配套工程项目",
        "章丘安置房A区项目",
        "章丘安置房B区项目",
        "青岛中法客厅项目",
        "济南王舍人项目",
        "金隅(常州) 钟楼项目",
        "杭州天成路216号长租公寓项目",
        "重庆东站项目",
        "长沙西站一分部项目",
        "长沙西站二分部项目",
        "长沙市轨道交通2号线西延二期项目",
        "天赐材料 (江门)电池项目",
        "遂溪江洪乐民100MW风电项目",
        "甘肃兰州机场项目",
        "宁夏宝丰健康城项目",
        "郑州轨道交通项目",
        "张家口虹桥路项目",
        "南七花园项目",
        "牡佳铁路站房三标段",
        "中电科 (银宝园) 项目",
        "十三五北部项目",
        "赤峰西站综合交通枢纽",
        "顺义装修项目",
        "宁夏宝丰医院项目",
        "崇礼客运枢纽项目",
        "保定ABO项目",
        "南京元器件项目",
        "D7120项目",
        "郭桑园村棚户区改造项目 EPC 工程总承包 (东尖塔 )",
        "上海市友谊三村老小区改造、幼儿图扩建工程",
        "上海干休所项目",
        "王寨小区棚户区改造项目 EPC 工程总承包",
        "大兴狼华纵二路",
      ],
      sf: "",
      plists: [
        { name: "顺义区天竺项目", belong: "京北分公司" },
        { name: "顺义区樱花园一期项目", belong: "京北分公司" },
        { name: "顺义区樱花园二期项目", belong: "京北分公司" },
        { name: "北京东站货场项目", belong: "京北分公司" },
        { name: "海淀区应急指挥中心项目", belong: "京北分公司" },
        { name: "北京轨道13号线市政项目 (保福寺 )", belong: "京北分公司" },

        { name: "大兴狼垡集体租赁住房项目", belong: "京南分公司" },
        { name: "人民大学通州新校区南区项目", belong: "京南分公司" },
        { name: "大兴区西红门居住用地项目", belong: "京南分公司" },
        { name: "人民大学通州新校区西区项目", belong: "京南分公司" },
        { name: "人民大学社会与人口学院项目", belong: "京南分公司" },
        { name: "东小马一地一级开发项目", belong: "京南分公司" },

        { name: "雄东片区B单元安置房项目", belong: "雄安分公司" },
        { name: "雄安新区大学园图书馆项目", belong: "雄安分公司" },
        { name: "启动区西部高中配套住房项目", belong: "雄安分公司" },
        { name: "启动区小学项目", belong: "雄安分公司" },

        { name: "眉山加州智慧城项目", belong: "四川分公司" },
        { name: "远大云锦项目", belong: "四川分公司" },
        { name: "德阳市群众文化活动中心项目", belong: "四川分公司" },
        { name: "东方氢能产业园项目", belong: "四川分公司" },
        { name: "光华校区人行道及周边环境维项目", belong: "四川分公司" },
        { name: "新建重庆至昆明高速铁路川渝段项目", belong: "四川分公司" },
        { name: "成都科创项目", belong: "四川分公司" },
        { name: "蓉南现代农产品流通中心项目", belong: "四川分公司" },
        { name: "五津街道28亩住宅地块开发项目", belong: "四川分公司" },
        { name: "渝昆高铁南溪站站前广场及连接线项目", belong: "四川分公司" },
        {
          name: "四川国际航展(ACC飞街片区)基础设施建设项目 --房屋建设及附属设施项目",
          belong: "四川分公司",
        },
        {
          name: "昭阳区母鹿荷花棚户区改造安置(1号、2号地 块)建设项目",
          belong: "四川分公司",
        },
        {
          name: "广元金草地健康产业带设计施工总承包项目",
          belong: "四川分公司",
        },
        {
          name: "南充北站站前基础配套设施工程南充北站站前 基础配套设施工程",
          belong: "四川分公司",
        },

        { name: "长沙机场改扩建工程综合交通枢纽项目", belong: "湖南分公司" },
        { name: "宜昌北站项目", belong: "湖南分公司" },
        { name: "芙蓉区生态新城六号安置小区项目", belong: "湖南分公司" },
        { name: "常益长项目", belong: "湖南分公司" },
        { name: "国网湖北黄石项目", belong: "湖南分公司" },
        { name: "中国供销平江商贸物流园项目一期", belong: "湖南分公司" },
      ],
      showlist: [],
    };
  },
  mounted() {
    console.log(mapdata);
    let that = this;
    let mychinachart = echarts.init(this.$refs.main);

    echarts.registerMap("china", chinaJson);

    var geoCoordMap = {
      直属项目: [116.28616, 39.85856],
      京北分公司: [116.300011, 39.84412],
      京南分公司: [116.22127, 39.90679],
      雄安分公司: [116.133545, 39.00024],
      四川分公司: [104.094643, 30.388172],
      湖南分公司: [112.84909, 28.32655],
    };
    var data = [
      {
        name: "直属项目",
        value: "城市副中心交通权纽项目",
      },
      {
        name: "京北分公司",
        value: "顺义区天竺项目",
      },
      {
        name: "京南分公司",
        value: "大兴狼垡集体租赁住房项目",
      },
      { name: "雄安分公司", value: "雄东片区B单元安置房项目" },
      { name: "湖南分公司", value: "长沙机场改扩建工程综合交通枢纽项目" },
      { name: "四川分公司", value: "蓉南现代农产品流通中心项目" },
    ];

    var convertData = function (data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      return res;
    };

    const option = {
      grid: {
        // 设置图表距离顶部,左侧，右侧和底部的高度
        top: "20px",
        left: "20px",
        right: "20px",
        bottom: "40px",
      },
      tooltip: {
        //提示框
        enterable: true,
        // 触发方式 mousemove, click, none, mousemove|click
        triggerOn: "click",
        // item 图形触发， axis 坐标轴触发， none 不触发
        trigger: "item",
        backgroundColor: "rgb(255,255,255,1)",
        show: true,
        position: (point, params, dom, rect, size) => {
          return [
            point[0] - dom.clientWidth / 2,
            point[1] - size.contentSize[1] - 25,
          ];
        },
        extraCssText:
          "white-space:unset;box-shadow: none;word-break:break-all;word-wrap:break-word;border:none;padding:0;width:220px;height:53px;", // 额外样式
        formatter: function (params) {
          return `<div style='position:relative'>
            <p style=" width:100%;height:100%;word-break:break-all;word-wrap:break-word;padding:7px 9px 6px 9px;text-align:center" class="tooltips">
          ${params.data.name}
                    </p>
                    <div style="position: absolute; bottom: -14px; left: calc(50% - 8px); width: 0; height: 0; overflow: hidden; border-width: 8px; border-color: #ffffff transparent transparent transparent; border-style: dashed dashed solid dashed;}"></div>

                    </div>`;
        },
      },

      geo: {
        map: "china",
        show: true,
        roam: true,
        zoom: 1.7,
        center: [104.0667, 35.9067], //地图中心点经纬度坐标
        itemStyle: {
          normal: {
            areaColor: "#9ECAF5",
            borderColor: "#fff", // 线
          },
          emphasis: {
            // 也是选中样式
            borderWidth: 2,
            borderColor: "#fff",
            areaColor: "rgba(16, 138, 209, 1)", //悬浮区背景
          },
        },
        emphasis: {
          label: { show: false },
        },
      },
      series: [
        {
          name: "Top5",
          type: "scatter",
          coordinateSystem: "geo",
          symbol: "image://" + require("../assets/image/point.png"), // 自定图标点图标
          symbolSize: [30, 30],
          data: mapdata.datas,
          emphasis: { label: { show: false } },
        },
      ],
    };
    mychinachart.setOption(option);
    mychinachart.on("mousedown", function (params) {
      if (params.componentType == "geo") {
        option.tooltip.show = false;
        that.sf = params.name;
        mychinachart.setOption(option);
        that.matchproject(that.sf);
      } else {
        option.tooltip.show = true;
        mychinachart.setOption(option);
      }
    });
    mychinachart.on("mouseup", function (params) {
      mychinachart.setOption(option);
    });
  },
  methods: {
    matchproject(e) {
      this.showlist = [];
      for (let i in mapdata.datas) {
        if (e == mapdata.datas[i].value[2]) {
          this.showlist.push(mapdata.datas[i]);
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
.plist {
  .lists {
    .listcon {
      .conright {
        margin-left: 1.04vw;
      }
      .consingle {
        display: flex;
        align-items: center;
        color: rgba(6, 25, 45, 0.6);
        font-size: 0.73vw;
        flex: 1;
      }
      padding-left: 0.52vw;
      border-bottom: 1px solid rgba(216, 216, 216, 0.7);
      min-height: 1.77vw;
      display: flex;
    }
    .listtitle {
      .titleright {
        margin-left: 1.04vw;
      }
      .titlesingle {
        display: flex;
        align-items: center;
        color: rgba(6, 25, 45, 0.8);
        font-size: 0.73vw;
        font-weight: 600;
        flex: 1;
      }
      background: rgba(242, 243, 247, 1);
      height: 1.77vw;
      display: flex;
      padding-left: 0.52vw;
    }
    width: 44.27vw;
    border: 1px solid rgba(222, 223, 230, 0.7);
    border-radius: 0.21vw;
  }
  width: 100%;
  min-height: 10.42vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
